import { __assign, __rest } from "tslib";
import { createAction } from 'redux-actions';
import { StreamType } from '../types';
import { actionKey } from './constants';
export var STREAM__WITH_OFFSET__INITIALIZE = "".concat(actionKey, "__INITIALIZE");
export var STREAM__WITH_OFFSET__FETCH = "".concat(actionKey, "__FETCH");
export var STREAM__WITH_OFFSET__FETCH_SUCCESS = "".concat(actionKey, "__FETCH_SUCCESS");
export var STREAM__WITH_OFFSET__FETCH_FAILURE = "".concat(actionKey, "__FETCH_FAILURE");
export var STREAM__WITH_OFFSET__INSERT_ITEMS = "".concat(actionKey, "__INSERT_ITEMS");
export var STREAM__WITH_OFFSET__FETCH_SUCCESS_DEDUPE = "".concat(actionKey, "__FETCH_SUCCESS_DEDUPE");
export var initialize = function (_a) {
    var nextOffset = _a.nextOffset, prevOffset = _a.prevOffset, baseInitializeParams = __rest(_a, ["nextOffset", "prevOffset"]);
    return (__assign(__assign({}, baseInitializeParams), { type: STREAM__WITH_OFFSET__INITIALIZE, streamType: StreamType.WITH_OFFSET, nextOffset: nextOffset, prevOffset: prevOffset }));
};
export var fetch = function (streamId) { return ({
    type: STREAM__WITH_OFFSET__FETCH,
    streamId: streamId,
}); };
export var fetchAll = function (streamId) { return ({
    type: STREAM__WITH_OFFSET__FETCH,
    streamId: streamId,
    all: true,
}); };
export var fetchSuccess = function (payload) { return (__assign({ type: STREAM__WITH_OFFSET__FETCH_SUCCESS }, payload)); };
export var fetchSuccessDeduped = function (payload) { return (__assign({ type: STREAM__WITH_OFFSET__FETCH_SUCCESS_DEDUPE }, payload)); };
export var insertItems = function (_a) {
    var streamId = _a.streamId, items = _a.items, offset = _a.offset, entities = _a.entities, doNotUpdateNextOffset = _a.doNotUpdateNextOffset;
    return ({
        type: STREAM__WITH_OFFSET__INSERT_ITEMS,
        streamId: streamId,
        items: items,
        offset: offset,
        entities: entities,
        doNotUpdateNextOffset: doNotUpdateNextOffset,
    });
};
export var fetchPrevious = createAction("".concat(actionKey, "__FETCH_PREVIOUS"), function (streamId) { return ({ streamId: streamId }); });
export var fetchPreviousSuccess = createAction("".concat(actionKey, "__FETCH_PREVIOUS_SUCCESS"), function (_a) {
    var streamId = _a.streamId, items = _a.items, entities = _a.entities, hasLess = _a.hasLess, prevOffset = _a.prevOffset, dedupeFunction = _a.dedupeFunction;
    return ({
        streamId: streamId,
        items: items,
        entities: entities,
        hasLess: hasLess,
        prevOffset: prevOffset,
        dedupeFunction: dedupeFunction,
    });
});
export var fetchAllSuccess = createAction("".concat(actionKey, "__FETCH_ALL_SUCCESS"), function (_a) {
    var streamId = _a.streamId, items = _a.items, entities = _a.entities;
    return ({
        streamId: streamId,
        items: items,
        entities: entities,
    });
});
export var emptyStream = createAction("".concat(actionKey, "__EMPTY"), function (streamId) { return ({ streamId: streamId }); });
export var resetStream = createAction("".concat(actionKey, "__RESET"), function (streamId) { return ({ streamId: streamId }); });
export * from '../base/actions';
//# sourceMappingURL=actions.js.map